/* eslint-disable import/no-namespace */
import _ from 'lodash';
import moment from 'moment';
import * as types from '../../actions';
import isEmpty from '../../../utils/functions/isEmpty';
import { reseteventfields, eventtypesEnum } from '../../../utils/constants';

const EVENT_TYPES = types.types.Event;
const SEASON_TYPES = types.types.Season;
const CENTER_TYPES = types.types.Center;

const resetdirector = {
  directorname: '',
  eventemail: '',
  directorssoemail: '',
  directorphone: '',
  directorcountry: '',
  directoraddress1: '',
  directoraddress2: '',
  directorcity: '',
  directorstate: '',
  directorzipcode: ''
};
const resetevent = {
  eventaddress: '',
  centercertnumber: null,
  centername: '',
  eventcity: '',
  eventstate: '',
  eventzipcode: '',
  eventcountry: 'usa'
};
function resetDivisionsOffered(divisionsOffered) {
  const divisions = [...divisionsOffered]
  divisions.map((division) => {
    division.offered = '';
  });
  return null; //divisions;
}
function setDivisionsOffered(season, seasons) {
  const divisionsOffered = [];
  const seasonDivisions = _.find(seasons, { id: parseInt(season) }).divisions;
  seasonDivisions && seasonDivisions.map((division) => {
    divisionsOffered.push({
      divisionId: division.id,
      name: division.name,
      offered: '',
      id: null,
      mixedAge: false,
    })
  });
  return null; // divisionsOffered;
}
function setEventDetails(details) {
  const eventDetails = {
    ...details,
  };
  return eventDetails;
}
const setEventLaneConditions = function (laneConditions) {
  if (laneConditions.oilRatio)
    return {
      oilRatio: laneConditions.oilRatio,
      dailyOilRatios: laneConditions.dailyOilRatios !== null ? laneConditions.dailyOilRatios.toString() : 'false',
      weeklyOilRatios: laneConditions.weeklyOilRatios !== null ? laneConditions.weeklyOilRatios.toString() : 'false',
      weeklyOilRatiosChangesAfter: laneConditions.weeklyOilRatiosChangesAfter,
    }
}
function setEventSetup(setup) {

  const {
    useMajorFraction,
    premierEvent,
    smartProviderId,
    offersScholarship,
    advancerPolicy,
    includeEnhancedAdvancerRatio,
    divisionsOffered,
    mixedAgeDivisionsOffered,
    advancerRatio,
    minAdvancerRatio,
    maxAdvancerRatio
  } = setup;
  const eventSetup = {
    useMajorFraction: useMajorFraction === true ? 'true' : 'false',
    premierEvent: premierEvent === true ? 'true' : 'false',
    smartProviderId: smartProviderId,
    offersScholarship: offersScholarship === true ? 'true' : 'false',
    advancerPolicy: advancerPolicy !== undefined ? advancerPolicy.toString() : '0',
    includeEnhancedAdvancerRatio: includeEnhancedAdvancerRatio === true ? 'true' : 'false',
    divisionsOffered,
    advancerRatio,
    mixedAgeDivisionsOffered,
    minAdvancerRatio,
    maxAdvancerRatio
  };
  return eventSetup;
}
// when creating an event we need to make sure the season has been setup.
function getEventEligibleSeasons(seasons) {
  return _.filter(seasons, {
    isSeasonSet: true
  })
}
const initOilRatio = function (size) {
  const oilRatio = [];
  const dimension = parseInt(size) || 0;
  let day;
  for (day = 1; day <= dimension; day++) {
    oilRatio.push({
      day: day,
      ratio: null,
      condition: '1'
    });
  }
  return oilRatio;

}
function getEventSeasonSettings(seasonId, eventSeasons) {
  const settings = _.find(eventSeasons, {
    'id': seasonId
  })
  if (settings !== undefined) {
    const {
      firstSemesterStartDate,
      rollOverDate,
      maxEventDuration,
      oilSportTo,
      oilChallengeFrom,
      oilChallengeTo,
      oilStandardFrom,
      oilStandardTo,
    } = settings
    return {
      firstSemesterStartDate,
      rollOverDate,
      maxEventDuration,
      oilSportTo,
      oilChallengeFrom,
      oilChallengeTo,
      oilStandardFrom,
      oilStandardTo,
    }
  }
}
const createMixedAgeDivision = function (stateValues) {
  const { seasons, eventseason, mixedAgeDivisionsOffered } = stateValues;
  const seasonDivisions = _.find(seasons, { id: parseInt(eventseason) }).divisions;
  const divisions = [...mixedAgeDivisionsOffered];
  const selectedParents = mixedAgeDivisionsOffered.filter(f => f.id > 0);
  const idsIndivisionsSelected = (selectedParents.map(division => division.divisions)).map((item) => (
    item.map((inneritem) => (inneritem.id))
  ));
  const flatteneSaveddArray = [].concat(...idsIndivisionsSelected);
  const currentSeason = seasons.find(s => s.IsCurrent = 1);
  const defaultMinRatio = currentSeason.minAdvancerRatio;
  // identify divisions that have been seleced/composed but have not been persisted -begin
  const unsavedDivisions = ((mixedAgeDivisionsOffered.filter(f => f.id === 0)).map(division => division.divisions)).map((item) => (
    item.map((inneritem) => (inneritem))
  ));
  const unsavedSelectedIds = unsavedDivisions.map(ud => ud.filter(f => f.selected === true)).map((divisions) => (
    divisions.map((division) => (division.id))
  ));
  const flattenedUnsavedArray = [].concat(...unsavedSelectedIds);
  // - end  
  const allSelectedDivisions = [...flatteneSaveddArray, ...flattenedUnsavedArray];
  const filteredseasonDivisions = seasonDivisions.filter(seasonDivision => !allSelectedDivisions.includes(seasonDivision.id));
  const entry = {
    id: 0,
    name: '',
    offered: ' ',
    advancerRatio: defaultMinRatio,
    divisions: []
  };
  filteredseasonDivisions.map((div) => {
    entry.divisions.push({
      id: div.id,
      name: div.name,
      selected: false
    });
  })
  divisions.push(entry);
  return divisions;

}
export default function eventinfo(state = {}, action) {

  switch (action.type) {

    case types.RESET_RETRIEVED_EVENT:
      {
        const response = {
          eventRetrieved: false,
          inWizardMode: true
        }
        return {
          ...state,
          values: {
            ...state.values,
            ...response
          },
          fields: {
            ...state.fields,
            ...response
          }
        }
      }
    case EVENT_TYPES.COPY_EVENT:
      {
        const copiedEventId = action.payload.data
        return {
          ...state,
          values: {
            ...state.values,
            copiedEventId
          },
          fields: {
            ...state.fields,
            copiedEventId
          }
        }
      }
    case EVENT_TYPES.APPROVE_EVENT_RULES:
      {
        return {
          ...state,
          values: {
            ...state.values,
            refreshSearchResults: true
          },
          fields: {
            ...state.fields,
            refreshSearchResults: true
          }
        }
      }
    case EVENT_TYPES.CANCEL_EVENT:
      {
        return {
          ...state,
          values: {
            ...state.values,
            refreshSearchResults: true
          },
          fields: {
            ...state.fields,
            refreshSearchResults: true
          }
        }
      }
    case EVENT_TYPES.DENY_EVENT_RULES:
      {
        return {
          ...state,
          values: {
            ...state.values,
            refreshSearchResults: true
          },
          fields: {
            ...state.fields,
            refreshSearchResults: true
          }
        }
      }
    case EVENT_TYPES.SET_CENTER:
      {
        const centerdetails = action.payload;
        const { name, certnumber, center } = centerdetails;
        const info = {
          centername: name,
          centercertnumber: certnumber,
          eventaddress: center.address,
          eventstate: center.state,
          eventzipcode: center.zip,
          eventcity: center.city,
          eventcountry: center.country,
          centers: [],
        }

        return {
          ...state,
          values: {
            ...state.values,
            ...info
          },
          fields: {
            ...state.fields,
            ...info
          }
        }
      }
    case EVENT_TYPES.SET_SEARCH_MODE:
      {
        const searchMode = action.payload;
        return {
          ...state,
          values: {
            ...state.values,
            searchMode,
          },
          fields: {
            ...state.fields,
            searchMode,
          }
        }
      }
    case EVENT_TYPES.SET_DEFAULT_EVENT_SEASON:
      {
        const { seasons } = state.values;
        let id = '';
        if (seasons !== undefined) {
          const currentSeason = _.find(seasons, { isCurrent: true });
          /*if((currentSeason !== null) || (currentSeason !== undefined))*/
          if ((currentSeason !== null) && (currentSeason !== undefined)) {
            id = currentSeason.id.toString();
          }
        }
        const settingsseason = id;
        const eventseason = id;
        const eventType = eventtypesEnum.Tournament;

        const defaults = {
          settingsseason,
          eventseason,
          eventType,
        }
        return {
          ...state,
          values: {
            ...state.values,
            ...defaults,
          },
          fields: {
            ...state.fields,
            ...defaults,
          }
        }
      }
    case EVENT_TYPES.RESET_WIZARD_STATE:
      {
        const wizardstate = {
          currentWizardStep: action.payload,
          saveComponentState: false,
          componentStateSaved: false
        }
        return {
          ...state,
          values: {
            ...state.values,
            ...wizardstate
          },
          fields: {
            ...state.fields,
            ...wizardstate
          }
        }
      }
    case EVENT_TYPES.RESET_EVENT_STATE:
      {
        const { eventseason, seasons } = state.values;
        const divisionsOffered = setDivisionsOffered(eventseason, seasons);
        const eventstate = {
          updateErrors: {},
          updateDetailsErrors: {},
          updateLaneErrors: {},
          updateSetupErrors: {},
          updateDepositErrors: {},
          updateRulesErrors: {},
          norecordsfound: false,
          divisionsOffered,
          mixedAgeDivisionsOffered: []
        }
        return {
          ...state,
          values: {
            ...state.values,
            ...eventstate
          },
          fields: {
            ...state.fields,
            ...eventstate
          }
        }
      }
    case EVENT_TYPES.RESET_EVENT_WIZARD: {
      const reset = {
        ...reseteventfields,
        prestineeventdetails: {},
        prestineinfo: {},
        prestineoilratio: {},
        prestinesetup: {},
      };

      return {
        ...state,
        values: {
          ...state.values,
          ...reset
        },
        fields: {
          ...state.fields,
          ...reset
        }
      }
    }
    case EVENT_TYPES.FETCHING_EVENT:
      {
        return {
          ...state,
          values: {
            ...state.values,
            fetchingevent: true
          },
          fields: {
            ...state.fields,
            fetchingevent: true
          }
        }
      }
    case EVENT_TYPES.FETCH_EVENT:
      {

        if (action.payload.data !== undefined) {
          const {
            currentWizardStep,
            lastStepCompleted,
            eventInfo,
            details,
            laneConditions,
            eventSetup,
            eventRules,
            status
          } = action.payload.data;

          const {
            centerAddress
          } = eventInfo;

          const {
            directorAddress
          } = eventInfo;

          const memberid = eventInfo.directorUsbcmemberId.split('-');

          const info = {
            eventId: eventInfo.eventId,
            eventseason: eventInfo.seasonId.toString(),
            eventcertnumber: eventInfo.certificationNumber,
            prestineeventcertnumber: eventInfo.certificationNumber,
            eventname: eventInfo.name,
            startdate: eventInfo.startDate,
            enddate: eventInfo.endDate,
            centername: eventInfo.centerName,
            centercertnumber: eventInfo.centerCertificationNumber,
            eventaddress: centerAddress.addressLine1,
            eventcity: centerAddress.city,
            eventstate: centerAddress.state,
            eventzipcode: centerAddress.zipCode,
            eventcountry: !isEmpty(centerAddress.country) ? centerAddress.country : 'US',
            directorname: eventInfo.directorName,
            directorssoemail: eventInfo.directorSsoemail,
            directorphone: eventInfo.directorPhoneNumber,
            eventemail: eventInfo.eventEmail,
            directoraddress1: directorAddress.addressLine1,
            directorcity: directorAddress.city,
            directorstate: directorAddress.state.toUpperCase(),
            directorzipcode: directorAddress.zipCode,
            directorcountry: directorAddress.country,
            memberidprefix: memberid[0],
            memberidsuffix: memberid[1],
            depositAmount: eventInfo.depositAmount,
            depositPaidOn: !isEmpty(eventInfo.depositPaidOn) ? moment(eventInfo.depositPaidOn).format('LL') : '',
            depositConfirmation: eventInfo.depositConfirmation,
            minRequiredDeposit: eventInfo.minRequiredDeposit,
            status: status
          };

          const eventdetails = setEventDetails(details);
          const lane = setEventLaneConditions(laneConditions);
          const setup = setEventSetup(eventSetup);

          const prestineinfo = info;
          const prestineeventdetails = eventdetails;
          const prestineoilratio = laneConditions.oilRatio;
          const prestinesetup = setup;
          const eventRetrieved = true;

          const {
            eventType,
            numberOfGames,
            numberOfWeeks,
            certificationNumber
          } = eventdetails;

          const {
            useMajorFraction,
            premierEvent,
            smartProviderId,
            offersScholarship,
            advancerPolicy,
            includeEnhancedAdvancerRatio,
            divisionsOffered,
            mixedAgeDivisionsOffered,
            advancerRatio,
          } = setup;

          const eventTypeId = eventType.toString();
          const oilRatio = lane.oilRatio;
          const dailyOilRatios = lane.dailyOilRatios;
          const weeklyOilRatios = lane.weeklyOilRatios;
          const weeklyOilRatiosChangesAfter = lane.weeklyOilRatiosChangesAfter;

          return {
            ...state,
            values: {
              ...state.values,
              ...info,
              ...eventRules,
              eventType: eventTypeId,
              oilRatio,
              dailyOilRatios,
              weeklyOilRatios,
              weeklyOilRatiosChangesAfter,
              numberOfGames,
              numberOfWeeks,
              certificationNumber,
              useMajorFraction,
              premierEvent,
              smartProviderId,
              offersScholarship,
              advancerPolicy,
              advancerRatio,
              divisionsOffered,
              mixedAgeDivisionsOffered,
              includeEnhancedAdvancerRatio,
              prestineinfo,
              prestineeventdetails,
              prestineoilratio,
              prestinesetup,
              copiedEventId: -1,
              eventRetrieved: eventRetrieved,
              inWizardMode: false,
              currentWizardStep: currentWizardStep,
              lastStepCompleted: lastStepCompleted,
              fetchingevent: false,
              updateErrors: {},
              updateDetailsErrors: {},
              updateDepositErrors: {},
              updateLaneErrors: {},
              updateSetupErrors: {}
            },
            fields: {
              ...state.fields,
              ...info,
              ...eventRules,
              eventType: eventTypeId,
              oilRatio,
              dailyOilRatios,
              weeklyOilRatios,
              weeklyOilRatiosChangesAfter,
              numberOfGames,
              numberOfWeeks,
              certificationNumber,
              useMajorFraction,
              premierEvent,
              smartProviderId,
              offersScholarship,
              advancerPolicy,
              includeEnhancedAdvancerRatio,
              prestineinfo,
              prestineeventdetails,
              prestineoilratio,
              prestinesetup,
              copiedEventId: -1,
              eventRetrieved: eventRetrieved,
              inWizardMode: false,
              currentWizardStep: currentWizardStep,
              fetchingevent: false,
              updateErrors: {},
              updateDetailsErrors: {},
              updateDepositErrors: {},
              updateLaneErrors: {},
              updateSetupErrors: {}
            }
          }
        }
        return state
      }
    case types.FETCH_COMPLETED_EVENTS:
      {
        if (action.payload.data != undefined) {
          const pendinguploads = action.payload.data
          return {
            ...state,
            values: {
              ...state.values,
              pendinguploads
            },
            fields: {
              ...state.fields,
              pendinguploads
            }
          }
        }
        return state
      }
    case CENTER_TYPES.FETCH_CENTER:
      {

        const recordsFound = action.payload !== undefined ? action.payload.length : 0

        if (recordsFound > 0) {
          const centers = action.payload

          if (recordsFound == 1) {
            const center = centers[0]

            const address = _.zipObject(['city', 'statezip'], center.citystatezip.split(','));

            const statezip = address.statezip.trim().split(' ')
            const eventstate = statezip[0]
            const zipcode = statezip[1]

            const details = {
              eventaddress: center.address,
              centercertnumber: center.certnumber,
              centername: center.name,
              eventcity: address.city,
              eventstate: eventstate,
              eventzipcode: zipcode,
              eventcountry: center.country,
              norecordsfound: false
            }
            return {
              ...state,
              values: {
                ...state.values,
                ...details
              },
              fields: {
                ...state.fields,
                ...details
              }
            }
          }
          else {
            return {
              ...state,
              values: {
                ...state.values,
                centers,
                eventcountry: 'usa',
                norecordsfound: false
              },
              fields: {
                ...state.fields,
                centers,
                eventcountry: 'usa',
                norecordsfound: false
              }
            }
          }
        }
        else {
          return {
            ...state,
            values: {
              ...state.values,
              ...resetevent,
              norecordsfound: true
            },
            fields: {
              ...state.fields,
              ...resetevent,
              norecordsfound: true
            }
          }
        }
      }
    case EVENT_TYPES.FETCH_MEMBER:
      {
        if (action.payload.statusCode === 404 || action.payload.value === undefined) {
          return {
            ...state,
            values: {
              ...state.values,
              ...resetdirector,
              nomembersfound: true
            },
            fields: {
              ...state.fields,
              ...resetdirector,
              nomembersfound: true
            }
          }
        } else {

          const member = action.payload.value
          const details = {
            directorname: member.firstName + ' ' + member.lastName,
            directorssoemail: member.emailAddress,
            eventemail: member.emailAddress,
            directorphone: member.eveningPhone == "" ? member.dayPhone : member.eveningPhone,
            directorcountry: member.country,
            directoraddress1: member.address1,
            directoraddress2: member.address2,
            directorcity: member.city,
            directorstate: member.state,
            directorzipcode: member.zip,
            nomembersfound: false
          }

          if (member) {
            return {
              ...state,
              values: {
                ...state.values,
                ...details
              },
              fields: {
                ...state.fields,
                ...details
              }
            }
          } else {
            return state
          }
        }
      }
    case SEASON_TYPES.FETCH_ACTIVE_SEASONS:
      {
        const seasons = action.payload.data
        let season
        let eventSeasons

        if (seasons && state) {
          season = seasons.find(function (season) {
            return season.isCurrent == true
          })
          eventSeasons = getEventEligibleSeasons(seasons)

          // get the settings for th default season. This is used for validation purposes
          const eventSeasonSettings = getEventSeasonSettings(season.id, eventSeasons)

          return {
            ...state,
            values: {
              ...state.values,
              seasons: eventSeasons,
              eventSeasonSettings: eventSeasonSettings,
              eventseason: season.id.toString(),
              seasonId: season.id.toString()
            },
            fields: {
              ...state.fields,
              seasons: eventSeasons,
              eventSeasonSettings: eventSeasonSettings,
              eventseason: season.id.toString(),
              seasonId: season.id.toString()
            }
          }
        }
        return state
      }
    case EVENT_TYPES.SAVE_EVENT_INFO:
      {
        if (action.payload) {
          const { eventId } = action.payload
          return {
            ...state,
            values: {
              ...state.values,
              eventId: eventId,
              updateErrors: {},
              componentStateSaved: true,
            },
            fields: {
              ...state.fields,
              eventId: eventId,
              updateErrors: {},
              componentStateSaved: true,
            }
          }
        } else {
          return state
        }
      }
    case EVENT_TYPES.SAVE_EVENT_INFO_ERROR:
      {
        if (action.payload) {
          const { data } = action.payload;
          return {
            ...state,
            values: {
              ...state.values,
              updateErrors: data,
              componentStateSaved: false,
              saveComponentState: false,
            },
            fields: {
              ...state.fields,
              updateErrors: data,
              componentStateSaved: false,
              saveComponentState: false,
            }
          }
        } else {
          return state
        }
      }
    case EVENT_TYPES.SAVE_EVENT_DETAILS_ERROR:
      {
        if (action.payload) {
          const { data } = action.payload;
          return {
            ...state,
            values: {
              ...state.values,
              updateDetailsErrors: data,
              componentStateSaved: false,
              saveComponentState: false,
            },
            fields: {
              ...state.fields,
              updateDetailsErrors: data,
              componentStateSaved: false,
              saveComponentState: false,
            }
          }
        } else {
          return state
        }
      }
    case EVENT_TYPES.SET_DEFAULT_WEEKS:
      {
        if (action.payload) {
          const weeks = action.payload;
          return {
            ...state,
            values: {
              ...state.values,
              numberOfWeeks: weeks,
            },
            fields: {
              ...state.fields,
              numberOfWeeks: weeks,
            }
          }
        }
        return state;
      }
    case EVENT_TYPES.SAVE_EVENT_DETAILS:
      {

        if (action.payload) {
          // const eventdetails = setEventDetails(action.payload)
          return {
            ...state,
            values: {
              ...state.values,
              componentStateSaved: true,
              updateDetailsErrors: {}
              // prestineeventdetails: eventdetails,
            },
            fields: {
              ...state.fields,
              componentStateSaved: true,
              updateDetailsErrors: {}
              // prestineeventdetails: eventdetails,
            }
          }
        } else {
          return state
        }
      }
    case EVENT_TYPES.SAVING_EVENT_OIL_CONDITIONS:
      {
        return {
          ...state,
          values: {
            ...state.values,
            savingLaneConditions: true
          },
          fields: {
            ...state.fields,
            savingLaneConditions: true
          }
        }
      }
    case EVENT_TYPES.SAVE_EVENT_OIL_CONDITIONS:
      {
        if (action.payload) {

          const { errors } = action.payload;
          const updateLaneErrors = errors.description !== null ? errors.description : {};
          const laneError = errors.description !== null ? errors.description[0] : '';

          const response = {
            componentStateSaved: laneError === '' ? true : false,
            savingLaneConditions: false,
            laneError,
            updateLaneErrors
          }

          return {
            ...state,
            values: {
              ...state.values,
              ...response,
            },
            fields: {
              ...state.fields,
              ...response,
            }
          }
        } else {
          return state
        }
      }
    case EVENT_TYPES.SAVE_EVENT_OIL_CONDITIONS_ERROR:
      {
        if (action.payload) {
          const { data } = action.payload;
          return {
            ...state,
            values: {
              ...state.values,
              updateLaneErrors: data,
              saveLaneConditionsInfo: false,
              componentStateSaved: false,
              saveComponentState: false,
            },
            fields: {
              ...state.fields,
              updateLaneErrors: data,
              saveLaneConditionsInfo: false,
              componentStateSaved: false,
              saveComponentState: false,
            }
          }
        } else {
          return state
        }
      }
    case EVENT_TYPES.SET_OIL_RATIO:
      {
        if (action.payload) {
          const { elem, value } = action.payload
          const oilRatio = [...state.values.oilRatio];
          oilRatio[parseInt(elem)].condition = value
          return {
            ...state,
            values: {
              ...state.values,
              oilRatio,
            },
            fields: {
              ...state.fields,
              oilRatio,
            }
          }
        }
        return state;
      }
    case EVENT_TYPES.INIT_OIL_RATIO:
      {
        if (action.payload) {
          const { size } = action.payload
          const oilRatio = initOilRatio(size)
          return {
            ...state,
            values: {
              ...state.values,
              oilRatio,
            },
            fields: {
              ...state.fields,
              oilRatio,
            }
          }
        }
        return state;
      }
    case EVENT_TYPES.ADD_MIXED_AGE_DIVISION:
      {
        const mixedAgeDivisionsOffered = createMixedAgeDivision(state.values)
        return {
          ...state,
          values: {
            ...state.values,
            mixedAgeDivisionsOffered,
          },
          fields: {
            ...state.fields,
            mixedAgeDivisionsOffered,
          }
        }

      }
    case EVENT_TYPES.UPLOADING_RULES_FILE:
      {
        return {
          ...state,
          values: {
            ...state.values,
            uploadingRules: true,
            successfileUpload: false,
          },
          fields: {
            ...state.fields,
            uploadingRules: true,
            successfileUpload: false,
          }
        }
      }
    case EVENT_TYPES.UPLOAD_RULES_FILE:
      {
        if (action.payload !== undefined) {
          const uploadResponse = action.payload;
          let rulesUploadedOn = null;
          let rulesApprovedOn = null;

          if (uploadResponse !== undefined) {
            rulesUploadedOn = uploadResponse.data.rulesUploadedOn;
            rulesApprovedOn = uploadResponse.data.rulesApprovedOn;
          }
          return {
            ...state,
            values: {
              ...state.values,
              uploadingRules: false,
              successfileUpload: true,
              componentStateSaved: true,
              rulesUploadedOn,
              rulesApprovedOn,
            },
            fields: {
              ...state.fields,
              uploadingRules: false,
              successfileUpload: true,
              componentStateSaved: true,
              rulesUploadedOn,
              rulesApprovedOn,
            }
          }
        } else {
          return state
        }
      }
    case EVENT_TYPES.RULES_PENDING_APPROVAL:
      {
        return {
          ...state,
          values: {
            ...state.values,
            uploadingRules: false,
            //successfileUpload:true,
            componentStateSaved: true,
          },
          fields: {
            ...state.fields,
            uploadingRules: false,
            // successfileUpload:true,
            componentStateSaved: true,
          }
        }
      }
    case EVENT_TYPES.SAVE_EVENT_SETUP:
      {
        if (action.payload) {
          const mixedAgeDivisionsOffered = action.payload;
          return {
            ...state,
            values: {
              ...state.values,
              componentStateSaved: true,
              mixedAgeDivisionsOffered: mixedAgeDivisionsOffered,
            },
            fields: {
              ...state.fields,
              componentStateSaved: true,
              mixedAgeDivisionsOffered: mixedAgeDivisionsOffered
            }
          }
        } else {
          return state
        }
      }
    case EVENT_TYPES.SAVE_EVENT_SETUP_ERROR:
      {
        if (action.payload) {
          const { data } = action.payload;
          return {
            ...state,
            values: {
              ...state.values,
              updateSetupErrors: data,
              componentStateSaved: false,
              saveComponentState: false,
            },
            fields: {
              ...state.fields,
              updateSetupErrors: data,
              updateErrors: data,
              componentStateSaved: false,
              saveComponentState: false,
            }
          }
        } else {
          return state
        }
      }
    case EVENT_TYPES.RESET_DIVISIONS_OFFERED:
      {
        const divisionsOffered = resetDivisionsOffered(state.values.divisionsOffered);
        return {
          ...state,
          values: {
            ...state.values,
            divisionsOffered,
          },
          fields: {
            ...state.fields,
            divisionsOffered,
          }
        }
      }
    case EVENT_TYPES.SAVING_EVENT_DEPOSIT:
      {
        return {
          ...state,
          values: {
            ...state.values,
            savingDeposit: true
          },
          fields: {
            ...state.fields,
            savingDeposit: true
          }
        }
      }
    case EVENT_TYPES.SAVE_EVENT_DEPOSIT:
      {
        if (action.payload) {

          const { errors, data } = action.payload;
          const updateDepositErrors = errors.description !== null ? errors.description : {};
          const depositError = errors.description !== null ? errors.description[0] : '';
          const depositPaidOn = depositError === '' ? moment(data.depositPaidOn).format('LL') : '';
          const depositConfirmation = data.depositConfirmation;

          const response = {
            componentStateSaved: depositError === '' ? true : false,
            savingDeposit: false,
            depositError,
            depositPaidOn,
            depositConfirmation,
            updateDepositErrors
          }
          return {
            ...state,
            values: {
              ...state.values,
              ...response,
            },
            fields: {
              ...state.fields,
              ...response,
            }
          }
        } else {
          return state
        }
      }
    case EVENT_TYPES.SAVE_EVENT_DEPOSIT_ERROR:
      {
        if (action.payload) {
          const { data } = action.payload;
          return {
            ...state,
            values: {
              ...state.values,
              updateDepositErrors: data,
              savingDeposit: false,
              componentStateSaved: false,
              saveComponentState: false,
            },
            fields: {
              ...state.fields,
              updateDepositErrors: data,
              savingDeposit: false,
              componentStateSaved: false,
              saveComponentState: false,
            }
          }
        } else {
          return state
        }
      }
    case EVENT_TYPES.PRESTINE_NAVIGATE_NEXT:
      {
        return {
          ...state,
          values: {
            ...state.values,
            componentStateSaved: true,
          },
          fields: {
            ...state.fields,
            componentStateSaved: true,
          }
        }
      }
    case types.SAVE_EVENT_SETUP:
      {
        if (action.payload.data) {
          const eventsetup = setEventSetup(action.payload.data)
          return {
            ...state,
            values: {
              ...state.values,
              prestinesetup: eventsetup
            },
            fields: {
              ...state.fields,
              prestinesetup: eventsetup
            }
          }
        } else {
          return state
        }
      }
    case types.SET_USER_ROLE:
      {

        const result = {
          hasAdminRole: action.payload
        }
        return {
          ...state,
          values: {
            ...state.values,
            ...result
          },
          fields: {
            ...state.fields,
            ...result
          }
        }
      }
    case types.SET_WIZARD_STEP:
      {
        const step = action.payload
        return {
          ...state,
          values: {
            ...state.values,
            currentWizardStep: step
          },
          fields: {
            ...state.fields,
            currentWizardStep: step
          }
        }
      }
    case EVENT_TYPES.DELETE_EVENT:
      {
        return {
          ...state,
          values: {
            ...state.values,
            refreshSearchResults: true
          },
          fields: {
            ...state.fields,
            refreshSearchResults: true
          }
        }
      }

    case EVENT_TYPES.DELETE_EVENT_DIVISION_OFFERED:
      {
        if (action.payload) {
          const data = action.payload;

          return {
            ...state,
            values: {
              ...state.values,
              mixedAgeDivisionsOffered: data
            },
            fields: {
              ...state.fields,
              mixedAgeDivisionsOffered: data
            }
          }
        }
        else {
          return state;
        }
      }
    case types.SET_EVENT_TYPE:
      {
        const eventtype = action.payload
        return {
          ...state,
          values: {
            ...state.values,
            eventtype
          },
          fields: {
            ...state.fields,
            eventtype
          }
        }
      }
    case types.SET_CERTIFICATION_NUMBER:
      {
        const {
          certificationNumber,
          forceCertificationNumber
        } = action.payload
        return {
          ...state,
          values: {
            ...state.values,
            certificationNumber,
            forceCertificationNumber

          },
          fields: {
            ...state.fields,
            certificationNumber,
            forceCertificationNumber
          }
        }
      }
    case types.SAVE_EVENT_CERT_NUMBER:
      {
        const {
          eventcertnumber
        } = state.values
        return {
          ...state,
          values: {
            ...state.values,
            prestineeventcertnumber: eventcertnumber

          },
          fields: {
            ...state.fields,
            prestineeventcertnumber: eventcertnumber
          }
        }
      }
    case types.fileUpload.SET_EVENT_RESULTS_FILENAME:
      {
        const eventResultsFileName = action.payload

        return {
          ...state,
          values: {
            ...state.values,
            eventResultsFileName
          },
          fields: {
            ...state.fields,
            eventResultsFileName
          }
        }
      }
    case types.fileUpload.RESET_EVENT_RESULTS_FILE:
      {

        const reset = {
          savingdata: false,
          datasaved: false,
          eventresults: {},
          eventResultsFileName: '',
          uploadingResultsFile: false,
          wrongFileUploadType: false,
          uploadErrorMessage: '',
          successfulUpload: false
        }
        return {
          ...state,
          values: {
            ...state.values,
            ...reset
          },
          fields: {
            ...state.fields,
            ...reset
          }
        }
      }
    case types.fileUpload.UPLOADING_RESULTS_FILE:
      {
        const uploadingfile = true
        return {
          ...state,
          values: {
            ...state.values,
            uploadingfile
          },
          fields: {
            ...state.fields,
            uploadingfile
          }
        }
      }
    case types.fileUpload.UPLOAD_EVENT_RESULTS:
      {
        const uploadErrorMessage = action.payload.data
        const uploadingfile = false
        const successfulUpload = (uploadErrorMessage == '') ? true : false

        return {
          ...state,
          values: {
            ...state.values,
            uploadingfile,
            uploadErrorMessage,
            successfulUpload
          },
          fields: {
            ...state.fields,
            uploadingfile,
            uploadErrorMessage,
            successfulUpload
          }
        }
      }
    case types.fileUpload.WRONG_FILE_UPLOAD_TYPE:
      {
        const wrongFileUploadType = true
        return {
          ...state,
          values: {
            ...state.values,
            wrongFileUploadType
          },
          fields: {
            ...state.fields,
            wrongFileUploadType
          }
        }
      }
    case types.fileUpload.RESET_UPLOAD_ERROR_MESSAGE:
      {
        const uploadErrorMessage = ''
        const successfulUpload = false
        return {
          ...state,
          values: {
            ...state.values,
            uploadErrorMessage,
            successfulUpload
          },
          fields: {
            ...state.fields,
            uploadErrorMessage,
            successfulUpload
          }
        }
      }
    case EVENT_TYPES.FETCHING_EVENTS:
      {
        return {
          ...state,
          values: {
            ...state.values,
            searchMode: true
          },
          fields: {
            ...state.fields,
            searchMode: true
          }
        }
      }

    case EVENT_TYPES.FETCH_EVENTS:
      {
        if (action.payload !== undefined) {
          const searchResults = action.payload;

          return {
            ...state,
            values: {
              ...state.values,
              searchMode: false,
              refreshSearchResults: false,
              searchResults
            },
            fields: {
              ...state.fields,
              searchMode: false,
              refreshSearchResults: false,
              searchResults
            }
          }
        }
        return state;
      }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/eventinfo.js